module.exports = __webpack_public_path__ + "44d537ab79f921fde5a28b2c1636f397.woff2";